import {makeTrackEvent} from './makeTrackEvent';

export type LogsPageAction =
  | 'Copy logs clicked'
  | 'Jump to bottom clicked'
  | 'Label filters applied'
  | 'Labels banner dismissed'
  | 'Labels banner docs clicked'
  | 'Logs searched'
  | 'Retry clicked'
  | 'Search results navigated'
  | 'Timestamp visibility toggled';

export type LogsPageLocation =
  | 'run-logs'
  | 'sweep-logs'
  | 'group-logs'
  | 'launch-agent-logs';

export type LogsPageEvent = {
  action: LogsPageAction;
  location: LogsPageLocation;
  numLabelsSelected?: number;
  isSearchActive?: boolean;
  isTimestampVisible?: boolean;
  errorType?: 'initial_load' | 'previous_page' | 'next_page';
};

export const trackLogsPage = makeTrackEvent<
  LogsPageEvent,
  {
    action: {
      description: 'the action that took place';
    };
    location: {
      description: 'location/context of the logs';
      exampleValues: ['run-logs', 'sweep-logs'];
    };
    numLabelsSelected: {
      description: 'number of labels selected when filtering logs by labels';
    };
    isSearchActive: {
      description: 'whether a search query is present';
    };
    isTimestampVisible: {
      description: 'whether timestamps are visible';
    };
    errorType: {
      description: 'for retry actions, which operation failed';
      exampleValues: ['initial_load', 'previous_page', 'next_page'];
    };
    _description: 'Tracks UX interactions on logs pages';
    _location: 'logs';
    _motivation: 'measure adoption of logs features';
  }
>('Logs page');
